import { useState } from 'react';
import { FETCH_STATUS } from '@hooks/useSWRFetch/types';
import { isNotProduction } from '@helpers/env';

export const useEnrichard = () => {
  const [status, setStatus] = useState<FETCH_STATUS>(FETCH_STATUS.IDLE);

  const postToEnrichard = async (body: string) => {
    setStatus(FETCH_STATUS.FETCHING);

    try {
      const res = await fetch('/catalog/api/enrichard', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
      });
      if (isNotProduction) {
        // eslint-disable-next-line
        console.log(
          `Got response from /api/enrichard: ${res.status}: ${res.statusText}`,
        );
      }
      setStatus(FETCH_STATUS.SUCCESS);
      if (!res.ok) {
        throw new Error(`${res.status}: ${res.statusText}`);
      }
      return res.ok;
    } catch (error) {
      setStatus(FETCH_STATUS.ERROR);
      if (isNotProduction) {
        console.log('Error calling enrichard: ', error); //eslint-disable-line
      }
      return false;
    }
  };

  return {
    status,
    actions: {
      postToEnrichard,
    },
  };
};
